(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fichu-measura-a11y"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('.fichu-measura-a11y');
    if (!root) return;
    const live = root.querySelector('.fichu-measura-a11y__live');
    const INPUT = '.atomic-pos-field input[data-measurement-type="length"]';
    let watched = null;
    let lastLines = null;
    let userTouched = 0;
    let timer = null;

    function enhance() {
      const input = document.querySelector(INPUT);
      if (!input) return null;
      if (!input.id) input.id = 'fichu-measura-length';
      if (!input.hasAttribute('aria-label')) input.setAttribute('aria-label', root.dataset.inputLabel);
      if (!input.hasAttribute('aria-describedby')) {
        let hint = document.getElementById('fichu-measura-length-hint');
        if (!hint) {
          hint = document.createElement('span');
          hint.id = 'fichu-measura-length-hint';
          hint.className = 'visually-hidden';
          hint.textContent = root.dataset.inputHint;
          input.insertAdjacentElement('afterend', hint);
        }
        input.setAttribute('aria-describedby', hint.id);
      }
      const field = input.closest('.atomic-pos-field') || input.parentElement;
      const steppers = field.querySelectorAll('.measura-stepper-btn');
      const minus = field.querySelector('.measura-minus') || steppers[0];
      const plus = field.querySelector('.measura-plus') || steppers[1];
      if (minus && !minus.hasAttribute('aria-label')) minus.setAttribute('aria-label', root.dataset.decrease);
      if (plus && !plus.hasAttribute('aria-label')) plus.setAttribute('aria-label', root.dataset.increase);
      return input.closest('[id^="shopify-block"]') || field.parentElement || field;
    }

    function lines(block) {
      return (block.innerText || '').split('\n').map((s) => s.trim()).filter(Boolean);
    }

    function announce(block) {
      const now = lines(block);
      if (lastLines && Date.now() - userTouched < 3000) {
        const changed = now.filter((l) => !lastLines.includes(l) && /\d/.test(l));
        if (changed.length) live.textContent = changed.join('. ') + '.';
      }
      lastLines = now;
    }

    function touch() {
      userTouched = Date.now();
    }

    function watch(block) {
      if (watched === block) return;
      watched = block;
      lastLines = lines(block);
      ['input', 'click', 'keydown'].forEach((type) => block.addEventListener(type, touch, true));
      new MutationObserver(() => {
        enhance();
        clearTimeout(timer);
        timer = setTimeout(() => announce(block), 400);
      }).observe(block, { subtree: true, childList: true, characterData: true });
    }

    // 04B.5 #24 (Sam): Measura prints «CHF 15.00 / m» as one text node inside the theme's price element.
    // The unit gets its own span so it can be greyed like on the cards; re-applied whenever the app re-renders,
    // no-op if the text has no «/ unit» tail.
    function unit() {
      document.querySelectorAll('.measura-unit-price').forEach((el) => {
        if (el.querySelector('.fichu-unit')) return;
        const m = (el.textContent || '').match(/^(.*?\S)(\s*\/\s*\S+)\s*$/);
        if (!m) return;
        el.textContent = m[1] + ' ';
        const s = document.createElement('span');
        s.className = 'fichu-unit';
        s.textContent = m[2].trim();
        el.appendChild(s);
      });
    }
    unit();
    new MutationObserver(unit).observe(document.body, { subtree: true, childList: true, characterData: true });

    const block = enhance();
    if (block) {
      watch(block);
    } else {
      new MutationObserver((records, observer) => {
        const found = enhance();
        if (found) {
          watch(found);
          observer.disconnect();
        }
      }).observe(document.body, { subtree: true, childList: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
